import { sendCategoryFilterEvent } from '@ebay/presence-ui/lib/event-triggers';

export default class {
    onUpdate() {
        // TODO: Button that has been re-rendered still has focus.
        // Find out why that is and if there's a way to avoid
        // the manual blurring below.
        const buttons = document.querySelectorAll('.str-category-carousel .filter-button');
        buttons.forEach(btn => {
            btn.blur();
        });
    }
    fetchCategoryListings(url, evt) {
        evt.originalEvent.preventDefault();
        sendCategoryFilterEvent({
            url: url,
            clickEvent: evt
        });
    }
}
